import AxiosUtils, { request } from 'Resources/AxiosUtils';
import { JSONType } from 'Typings/Global';
import { parseResource, parseResourceFormData } from 'Models/Resource/resourceParsers';
import { TResource } from 'Models/Resource/@types';


class AlbumModel {

  static getAllAlbums = async (params?: Record<string, any>): Promise<JSONType[]> => {
    const res = await request<JSONType[]>({
      url: '/albums',
      method: 'GET',
      params,
    });
    return res.map(parseResource);
  };

  static getAlbum = async (id: string, params?: Record<string, any>): Promise<TResource> => {
    const res = await request<JSONType>({
      url: `/resources/${id}/find/Album`,
      method: 'GET',
      params,
    });
    return parseResource(res);
  };

  static updateAlbum = async (data: Partial<TResource> & { id: string }): Promise<TResource> => {
    const res = await request({
      url: `/albums/${data.id}`,
      method: 'patch',
      data: { ...parseResourceFormData(data) },
    }).catch(AxiosUtils.throwError);
    if (!res) return Promise.reject();
    return { ...data, ...parseResource(res) } as TResource;
  };

  static deleteAlbums = async (ids: string[]): Promise<JSONType> => {
    const res = await request<JSONType>({
      url: '/albums/trash',
      method: 'DELETE',
      data: { ids },
    });
    return res;
  };

  static togglePublishAlbum = (id: string, publish: boolean): Promise<JSONType> =>
    request<JSONType>({
      url: `/albums/${id}/publish`,
      method: 'post',
      params: { publish },
    });
}

export default AlbumModel;
